__turbopack_context__.v({
  "content": "DescriptionBlock-module-scss-module__i50w0G__content",
  "description": "DescriptionBlock-module-scss-module__i50w0G__description",
  "descriptionBlock": "DescriptionBlock-module-scss-module__i50w0G__descriptionBlock",
  "stack-module-0": "DescriptionBlock-module-scss-module__i50w0G__stack-module-0",
  "stack-module-1": "DescriptionBlock-module-scss-module__i50w0G__stack-module-1",
  "stack-module-10": "DescriptionBlock-module-scss-module__i50w0G__stack-module-10",
  "stack-module-11": "DescriptionBlock-module-scss-module__i50w0G__stack-module-11",
  "stack-module-12": "DescriptionBlock-module-scss-module__i50w0G__stack-module-12",
  "stack-module-13": "DescriptionBlock-module-scss-module__i50w0G__stack-module-13",
  "stack-module-14": "DescriptionBlock-module-scss-module__i50w0G__stack-module-14",
  "stack-module-15": "DescriptionBlock-module-scss-module__i50w0G__stack-module-15",
  "stack-module-16": "DescriptionBlock-module-scss-module__i50w0G__stack-module-16",
  "stack-module-17": "DescriptionBlock-module-scss-module__i50w0G__stack-module-17",
  "stack-module-18": "DescriptionBlock-module-scss-module__i50w0G__stack-module-18",
  "stack-module-19": "DescriptionBlock-module-scss-module__i50w0G__stack-module-19",
  "stack-module-2": "DescriptionBlock-module-scss-module__i50w0G__stack-module-2",
  "stack-module-20": "DescriptionBlock-module-scss-module__i50w0G__stack-module-20",
  "stack-module-3": "DescriptionBlock-module-scss-module__i50w0G__stack-module-3",
  "stack-module-4": "DescriptionBlock-module-scss-module__i50w0G__stack-module-4",
  "stack-module-5": "DescriptionBlock-module-scss-module__i50w0G__stack-module-5",
  "stack-module-6": "DescriptionBlock-module-scss-module__i50w0G__stack-module-6",
  "stack-module-7": "DescriptionBlock-module-scss-module__i50w0G__stack-module-7",
  "stack-module-8": "DescriptionBlock-module-scss-module__i50w0G__stack-module-8",
  "stack-module-9": "DescriptionBlock-module-scss-module__i50w0G__stack-module-9",
  "z-base": "DescriptionBlock-module-scss-module__i50w0G__z-base",
  "z-content": "DescriptionBlock-module-scss-module__i50w0G__z-content",
  "z-footer": "DescriptionBlock-module-scss-module__i50w0G__z-footer",
  "z-header": "DescriptionBlock-module-scss-module__i50w0G__z-header",
  "z-hero": "DescriptionBlock-module-scss-module__i50w0G__z-hero",
  "z-logo": "DescriptionBlock-module-scss-module__i50w0G__z-logo",
  "z-logo-effect": "DescriptionBlock-module-scss-module__i50w0G__z-logo-effect",
  "z-navigation": "DescriptionBlock-module-scss-module__i50w0G__z-navigation",
  "z-sub": "DescriptionBlock-module-scss-module__i50w0G__z-sub",
});
